import React, { Component } from "react"
import { getActiveLanguage, getTranslate, Translate } from "react-localize-redux"
import LangEgiftFooter from "../../resources/modules/LangEgiftFooter"
import vnFlag from "../../images/flags/vn_flag.png"
import usFlag from "../../images/flags/vn_flag.png"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

class EgiftFooter extends Component {
	constructor(props) {
		super(props)
		this.state = {
			subItems: LangEgiftFooter.footer.subItems,
			items: LangEgiftFooter.footer.items,
			openAccordion: null,
		}
	}

	handleOnLabelClick = (itemTitle) => {
		this.setState({
			openAccordion: this.state.openAccordion === itemTitle ? null : itemTitle,
		})
	}

	generateMainFooterItems = (translate, item) => {
		const { openAccordion } = this.state
		return (
			<div
				className="info_block column size12of12 med_size4of12 lg_size2of12"
				key={item.title}>
				<StyledH4>
					<a href={translate("footer." + item.title + ".path")}>
						{translate("footer." + item.title + ".text")}
					</a>
					<Label
						htmlFor={"footer_link_group_" + item.title}
						className={[openAccordion === item.title ? "open" : ""]}
						data-icon="⌄"
						tabIndex={0}
						onClick={() => this.handleOnLabelClick(item.title)}
					/>
				</StyledH4>
				<input
					id={"footer_link_group_" + item.title}
					name="footer"
					type="radio"
					aria-hidden="true"
				/>
				<FooterOl openAccordion={openAccordion === item.title}>
					{item.subItems.map((sub) => {
						return (
							<li key={sub}>
								<a href={translate("footer." + sub + ".path")}>
									{translate("footer." + sub + ".text")}
								</a>
							</li>
						)
					})}
				</FooterOl>
			</div>
		)
	}
	generateSubFooterItems = (translate, subItem) => {
		return (
			<li key={subItem}>
				<a
					href={translate("footer." + subItem + ".path")}
					title={translate("footer." + subItem + ".text")}>
					{translate("footer." + subItem + ".text")}
				</a>
			</li>
		)
	}
	populateFlag = (activeLanguage) => {
		if (activeLanguage) {
			switch (activeLanguage.code) {
				case "vi":
					return <img src={vnFlag} alt="" data-aspect={0} className="flag" />
				case "en":
					return <img src={usFlag} alt="" data-aspect={0} className="flag" />
				default:
					return <img src={vnFlag} alt="" data-aspect={0} className="flag" />
			}
		}
	}

	render() {
		const pathname = this.props.location.pathname
		let _t = pathname.split("/")
		const restOfpath = "/" + _t.slice(2).join("/") + this.props.location.search // discard ["", "en"] and join the rest

		return (
			<Translate>
				{(translate, activeLanguage, languages) => {
					return (
						<footer id="footer" tabIndex={0} className="footer">
							<FooterTop>
								<div className="container-fluid">
									<div className="grid">
										<div className="sizeFlexWrap">
											<ul className="sb-social-icons column size12of12 med_size4of12 ">
												<li className="facebook">
													<FBLinkIcon
														href="https://www.facebook.com/starbucksvietnam"
														title="Facebook"></FBLinkIcon>
												</li>
												<li className="instagram">
													<IGLinkIcon
														href="https://www.instagram.com/starbucksvietnam/"
														target="_blank"
														rel="noopener noreferrer"
														title="Instagram Starbucks Vietnam"></IGLinkIcon>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</FooterTop>
							<FooterMain>
								<div className="container-fluid">
									<div className="grid">
										<div className="footer_global accordion sizeFlexWrap">
											{this.state.items.map((item) =>
												this.generateMainFooterItems(
													translate,
													item
												)
											)}
										</div>
									</div>
								</div>
							</FooterMain>
							<FooterBottom>
								<div className="container-fluid">
									<div className="grid">
										<div className="column size12of12">
											<ul className="site_selection">
												<li className="change">
													<a href="" className="culture">
														<span className="culture">
															<span>
																{this.populateFlag(
																	activeLanguage
																)}{" "}
															</span>
														</span>
													</a>
												</li>
												<li className="native language">
													<Translate id="footer.current-language" />
												</li>
												{languages.map((lang) => (
													<li
														key={lang.code}
														className="change language">
														<Link
															to={
																"/" +
																lang.code +
																restOfpath
															}>
															<span
																title={translate(
																	`footer.footerMenu._${lang.name}`
																)}
																style={{
																	cursor: "pointer",
																	fontWeight: 700,
																}}>
																{translate(
																	`footer.footerMenu._${lang.name}`
																)}
															</span>
														</Link>
													</li>
												))}
											</ul>
										</div>
										<div className="column size12of12">
											<ul className="footer_sub">
												{this.state.subItems.map((item) =>
													this.generateSubFooterItems(
														translate,
														item
													)
												)}
											</ul>
											<div
												id="teconsent"
												className="teconsent_showBorder"
												consent="0,1,2"
												style={{ display: "inline", opacity: 1 }}>
												<a
													id="icon-id07514045704159431"
													tabIndex={0}
													lang="vi"
													style={{ cursor: "pointer" }}
													href="/home">
													<Translate id="footer.cookie.text" />
												</a>
											</div>
										</div>
										<div className="column size12of12">
											<p className="footer_copyright">
												<Translate id="footer.copyright" />
											</p>
										</div>
									</div>
								</div>
							</FooterBottom>
						</footer>
					)
				}}
			</Translate>
		)
	}
}

const StyledH4 = styled.h4`
	font-size: 1.14rem;
`

const Label = styled.label`
	transition: all ease 0.2s;
	outline: none;

	&.open {
		transform: rotate(180deg);
	}
`

const FooterOl = styled.ol`
	transition: all ease 0.2s;
	max-height: auto;

	@media screen and (max-width: 767px) {
		margin: 0 !important;
		max-height: ${(p) => (p.openAccordion ? "700px" : 0)};
	}
`

const FooterMain = styled.div``

const FooterBottom = styled.div`
	padding: 0 0 45px;
`

const FooterTop = styled.div`
	padding: 35px 0;
	background: #f0f0f0;
	border-top: 3px solid #fff;
	border-bottom: 3px solid #fff;
`

const FBLinkIcon = styled.a`
	background: url(https://en.starbucks.vn/static/images/social_icons.png) no-repeat;
	background-position: 0 0;
	background-size: auto 100%;
	width: 25px;
	height: 31px;
	display: inline-block;
`

const IGLinkIcon = styled.a`
	background: url(https://en.starbucks.vn/static/images/social_icons.png) no-repeat;
	background-position: -112px 0;
	background-size: auto 100%;
	width: 28px;
	height: 31px;
	display: inline-block;
`

const mapStateToProps = ({ locale }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
})

export default connect(mapStateToProps)(EgiftFooter)
